import { Routes, Route } from "react-router-dom"

import Home from "./pages/Home"
import ClassifyPage from "./pages/Classify"
import SummarizePage from "./pages/Summarize"
import NerPosPage from "./pages/NerPos"

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/classify" element={<ClassifyPage />} />
      <Route path="/summarize" element={<SummarizePage />} />
      <Route path="/nerpos" element={<NerPosPage />} />
    </Routes>
  )
}